var professions ={
  professions: {
    unemployed: {
    txt_id: "unemployed",
    name: "Not Employed"
    },
    self_employed: {
    txt_id: "self_employed",
    name: "Self-Employed"
    },
    student: {
    txt_id: "student",
    name: "Student"
    },
    accountant_broker: {
    txt_id: "accountant_broker",
    name: "Accountant/Broker"
    },
    airline_crew: {
    txt_id: "airline_crew",
    name: "Airline Crew"
    },
    caregiver: {
    txt_id: "caregiver",
    name: "Caregiver"
    },
    food_beverage_staff: {
    txt_id: "food_beverage_staff",
    name: "Food/Beverage Staff"
    },
    custodian: {
    txt_id: "custodian",
    name: "Custodian"
    },
    dentist_hygenist: {
    txt_id: "dentist_hygenist",
    name: "Dentist/Hygenist"
    },
    designer_artist: {
    txt_id: "designer_artist",
    name: "Designer/Artist"
    },
    beautician: {
    txt_id: "beautician",
    name: "Beautician"
    },
    ceo_executive: {
    txt_id: "ceo_executive",
    name: "CEO Executive"
    },
    curator: {
    txt_id: "curator",
    name: "Curator"
    },
    programmer: {
    txt_id: "programmer",
    name: "Programmer"
    },
    wellness_specialist: {
    txt_id: "wellness_specialist",
    name: "Wellness Specialist"
    },
    medical_personnel: {
    txt_id: "medical_personnel",
    name: "Medical Personnel"
    },
    hospitality_staff: {
    txt_id: "hospitality_staff",
    name: "Hospitality Staff"
    },
    entertainment_staff: {
    txt_id: "entertainment_staff",
    name: "Entertainment Staff"
    },
    journalist_editor: {
    txt_id: "journalist_editor",
    name: "Journalist/Editor"
    },
    law_enforcer: {
    txt_id: "law_enforcer",
    name: "Law Enforcer"
    },
    legal_adviser: {
    txt_id: "legal_adviser",
    name: "Legal Adviser"
    },
    engineer_planner: {
    txt_id: "engineer_planner",
    name: "Engineer/Planner"
    },
    manager: {
    txt_id: "manager",
    name: "Manager"
    },
    photographer: {
    txt_id: "photographer",
    name: "Photographer"
    },
    tradesman: {
    txt_id: "tradesman",
    name: "Tradesman"
    },
    realtor: {
    txt_id: "realtor",
    name: "Realtor"
    },
    retail_staff: {
    txt_id: "retail_staff",
    name: "Retail Staff"
    },
    social_worker: {
    txt_id: "social_worker",
    name: "Social Worker"
    },
    educator: {
    txt_id: "educator",
    name: "Educator"
    },
    technician: {
    txt_id: "technician",
    name: "Technician"
    },
    driver: {
    txt_id: "driver",
    name: "Driver"
    },
    vet_vet_technician: {
    txt_id: "vet_vet_technician",
    name: "Vet/Vet Technician"
    },
    other: {
    txt_id: "other",
    name: "Other"
    }
  }
}

module.exports = professions
